// 动画和过渡效果配置

// 过渡时间
export const transitions = {
  shortest: 150,
  shorter: 200,
  short: 250,
  standard: 300,
  complex: 375,
  enteringScreen: 225,
  leavingScreen: 195,
};

// 缓动函数 - 增强版
export const easing = {
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
  // 自定义缓动
  bounce: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
  elastic: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
  smooth: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
  // 新增缓动函数
  backIn: 'cubic-bezier(0.6, -0.28, 0.735, 0.045)',
  backOut: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
  backInOut: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
  circIn: 'cubic-bezier(0.6, 0.04, 0.98, 0.335)',
  circOut: 'cubic-bezier(0.075, 0.82, 0.165, 1)',
  circInOut: 'cubic-bezier(0.785, 0.135, 0.15, 0.86)',
  expoIn: 'cubic-bezier(0.95, 0.05, 0.795, 0.035)',
  expoOut: 'cubic-bezier(0.19, 1, 0.22, 1)',
  expoInOut: 'cubic-bezier(1, 0, 0, 1)',
  quadIn: 'cubic-bezier(0.55, 0.085, 0.68, 0.53)',
  quadOut: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
  quadInOut: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
  // 特殊效果缓动
  anticipate: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
  overshoot: 'cubic-bezier(0.175, 0.885, 0.32, 1.4)',
  spring: 'cubic-bezier(0.68, -0.6, 0.32, 1.6)',
};

// 预定义动画
export const animations = {
  // 淡入淡出
  fadeIn: {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  fadeOut: {
    from: { opacity: 1 },
    to: { opacity: 0 },
  },
  
  // 滑动
  slideInUp: {
    from: { transform: 'translateY(100%)', opacity: 0 },
    to: { transform: 'translateY(0)', opacity: 1 },
  },
  slideInDown: {
    from: { transform: 'translateY(-100%)', opacity: 0 },
    to: { transform: 'translateY(0)', opacity: 1 },
  },
  slideInLeft: {
    from: { transform: 'translateX(-100%)', opacity: 0 },
    to: { transform: 'translateX(0)', opacity: 1 },
  },
  slideInRight: {
    from: { transform: 'translateX(100%)', opacity: 0 },
    to: { transform: 'translateX(0)', opacity: 1 },
  },
  
  // 缩放
  scaleIn: {
    from: { transform: 'scale(0)', opacity: 0 },
    to: { transform: 'scale(1)', opacity: 1 },
  },
  scaleOut: {
    from: { transform: 'scale(1)', opacity: 1 },
    to: { transform: 'scale(0)', opacity: 0 },
  },
  
  // 弹跳
  bounceIn: {
    '0%': { transform: 'scale(0.3)', opacity: 0 },
    '50%': { transform: 'scale(1.05)' },
    '70%': { transform: 'scale(0.9)' },
    '100%': { transform: 'scale(1)', opacity: 1 },
  },
  
  // 旋转
  rotateIn: {
    from: { transform: 'rotate(-200deg)', opacity: 0 },
    to: { transform: 'rotate(0)', opacity: 1 },
  },
  
  // 脉冲
  pulse: {
    '0%': { transform: 'scale(1)' },
    '50%': { transform: 'scale(1.05)' },
    '100%': { transform: 'scale(1)' },
  },
  
  // 摇摆
  shake: {
    '0%, 100%': { transform: 'translateX(0)' },
    '10%, 30%, 50%, 70%, 90%': { transform: 'translateX(-10px)' },
    '20%, 40%, 60%, 80%': { transform: 'translateX(10px)' },
  },
  
  // 加载动画
  spin: {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' },
  },
  
  // 呼吸效果
  breathe: {
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: 0.4 },
  },
  
  // 新增动画效果
  // 弹性进入
  elasticIn: {
    '0%': { transform: 'scale(0)', opacity: 0 },
    '50%': { transform: 'scale(1.2)', opacity: 0.8 },
    '75%': { transform: 'scale(0.9)', opacity: 0.9 },
    '100%': { transform: 'scale(1)', opacity: 1 },
  },
  
  // 翻转效果
  flipIn: {
    '0%': { transform: 'perspective(400px) rotateY(90deg)', opacity: 0 },
    '40%': { transform: 'perspective(400px) rotateY(-20deg)' },
    '60%': { transform: 'perspective(400px) rotateY(10deg)' },
    '80%': { transform: 'perspective(400px) rotateY(-5deg)' },
    '100%': { transform: 'perspective(400px) rotateY(0deg)', opacity: 1 },
  },
  
  // 光晕效果
  glow: {
    '0%, 100%': { boxShadow: '0 0 5px rgba(76, 175, 80, 0.3)' },
    '50%': { boxShadow: '0 0 20px rgba(76, 175, 80, 0.8), 0 0 30px rgba(76, 175, 80, 0.4)' },
  },
  
  // 波纹效果
  ripple: {
    '0%': { transform: 'scale(0)', opacity: 1 },
    '100%': { transform: 'scale(4)', opacity: 0 },
  },
  
  // 打字机效果
  typewriter: {
    '0%': { width: '0%' },
    '100%': { width: '100%' },
  },
  
  // 渐变背景动画
  gradientShift: {
    '0%': { backgroundPosition: '0% 50%' },
    '50%': { backgroundPosition: '100% 50%' },
    '100%': { backgroundPosition: '0% 50%' },
  },
  
  // 浮动效果
  float: {
    '0%, 100%': { transform: 'translateY(0px)' },
    '50%': { transform: 'translateY(-10px)' },
  },
  
  // 摆动效果
  swing: {
    '0%, 100%': { transform: 'rotate(0deg)' },
    '20%': { transform: 'rotate(15deg)' },
    '40%': { transform: 'rotate(-10deg)' },
    '60%': { transform: 'rotate(5deg)' },
    '80%': { transform: 'rotate(-5deg)' },
  },
  
  // 心跳效果
  heartbeat: {
    '0%': { transform: 'scale(1)' },
    '14%': { transform: 'scale(1.3)' },
    '28%': { transform: 'scale(1)' },
    '42%': { transform: 'scale(1.3)' },
    '70%': { transform: 'scale(1)' },
  },
};

// 创建过渡字符串的辅助函数
export const createTransition = (props, options = {}) => {
  const {
    duration = transitions.standard,
    easing: easingFunction = easing.easeInOut,
    delay = 0,
  } = options;
  
  const propsArray = Array.isArray(props) ? props : [props];
  
  return propsArray
    .map(prop => `${prop} ${duration}ms ${easingFunction} ${delay}ms`)
    .join(', ');
};

// 常用过渡组合 - 增强版
export const commonTransitions = {
  all: createTransition('all'),
  transform: createTransition('transform'),
  opacity: createTransition('opacity'),
  background: createTransition('background-color'),
  border: createTransition('border-color'),
  shadow: createTransition('box-shadow'),
  color: createTransition('color'),
  // 组合过渡
  hover: createTransition(['transform', 'box-shadow', 'background-color']),
  button: createTransition(['background-color', 'box-shadow', 'border-color']),
  card: createTransition(['transform', 'box-shadow']),
  input: createTransition(['border-color', 'box-shadow']),
  // 新增过渡组合
  smooth: createTransition('all', { duration: transitions.standard, easing: easing.smooth }),
  bounce: createTransition('transform', { duration: transitions.complex, easing: easing.bounce }),
  elastic: createTransition('all', { duration: transitions.complex, easing: easing.elastic }),
  spring: createTransition('transform', { duration: transitions.complex, easing: easing.spring }),
  fade: createTransition('opacity', { duration: transitions.short, easing: easing.easeOut }),
  slide: createTransition('transform', { duration: transitions.standard, easing: easing.easeInOut }),
  scale: createTransition('transform', { duration: transitions.shorter, easing: easing.backOut }),
  // 特殊场景过渡
  modal: createTransition(['opacity', 'transform'], { duration: transitions.enteringScreen, easing: easing.easeOut }),
  drawer: createTransition('transform', { duration: transitions.enteringScreen, easing: easing.sharp }),
  tooltip: createTransition(['opacity', 'transform'], { duration: transitions.shorter, easing: easing.easeInOut }),
  menu: createTransition(['opacity', 'transform'], { duration: transitions.short, easing: easing.easeOut }),
  snackbar: createTransition(['opacity', 'transform'], { duration: transitions.enteringScreen, easing: easing.easeOut }),
  fab: createTransition(['transform', 'box-shadow'], { duration: transitions.shorter, easing: easing.backOut }),
  ripple: createTransition(['transform', 'opacity'], { duration: 600, easing: easing.easeOut }),
};

export default {
  transitions,
  easing,
  animations,
  createTransition,
  commonTransitions,
};